export const TX_TOKENIZE_AMOUNT_SET = "TX_TOKENIZE_AMOUNT_SET";
export const TX_TOKENIZE_MEMO_SET = "TX_TOKENIZE_MEMO_SET";
export const TX_TOKENIZE_MODAL_SHOW = "TX_TOKENIZE_MODAL_SHOW";
export const TX_TOKENIZE_MODAL_HIDE = "TX_TOKENIZE_MODAL_HIDE";
export const TOKENIZE_SHARES_FETCH_SUCCESS = "TOKENIZE_SHARES_FETCH_SUCCESS";
export const TOKENIZE_SHARES_REWARDS_FETCH_SUCCESS =
  "TOKENIZE_SHARES_REWARDS_FETCH_SUCCESS";
export const TX_TOKENIZE_OWNER_ADDRESS_SET = "TX_TOKENIZE_OWNER_ADDRESS_SET";
export const TX_TOKENIZE_SHARE_STATUS_SET = "TX_TOKENIZE_SHARE_STATUS_SET";
export const TX_TOKENIZE_SHARE_STATUS_FAILED =
  "TX_TOKENIZE_SHARE_STATUS_FAILED";
export const TX_TOKENIZE_SHARE_STATUS_SUCCESS =
  "TX_TOKENIZE_SHARE_STATUS_SUCCESS";
export const TX_TOKENIZE_TXN_INFO_SET = "TX_TOKENIZE_TXN_INFO_SET";
export const TX_TOKENIZE_BUTTON_SET = "TX_TOKENIZE_BUTTON_SET";
export const TX_TOKENIZE_PARAMS_SET = "TX_TOKENIZE_PARAMS_SET";
